module.exports = __webpack_public_path__ + "static/media/ST6.af0df70e.mp3";